export default {"src":"/_next/static/media/pair-1.b2a4c5cc.svg","height":342,"width":580,"blurWidth":0,"blurHeight":0};